import { Grid, Filter, Page, Sort, Toolbar, Edit, QueryCellInfoEventArgs, Column, RowSelectingEventArgs, RecordClickEventArgs } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';
import { ModalHelper } from '../../Helpers/ModalHelper';
// import { ConfirmModal } from '../Helpers/ConfirmModal';

export class DataHubIndexManager {

    constructor(private containerElement: JQuery) { }

    private dataHubItemsGrid : Grid;
    private sendToErpLogItemPopup : ModalHelper; 

    public initialize() {
        var self = this;

        Grid.Inject(Filter, Page, Sort, Toolbar, Edit);

        self.initializeDataHubItemsTable();
    }

    private initializeDataHubItemsTable() {
        var self = this;

        var sendToCloudErpEnabled = (self.containerElement.data('export-to-erp-enabled') == 'True' || self.containerElement.data('export-to-erp-enabled') == 'true');

        this.sendToErpLogItemPopup = new ModalHelper();
        this.sendToErpLogItemPopup.createModal("send-to-erp-log-item-popup", true);

        //var loadingContainer = self.containerElement.find('#loading-container');
        var dataHubItemsTableContainer = self.containerElement.find('#data-hub-items-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#DataHubDocHeadersGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        let data: DataManager = new DataManager({
            url: '/api/company/datahub/list',
            adaptor: new WebApiAdaptor,
        });

        var gridColumns : any = 
        [
            { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
            { field: 'CreationDateTimeString', headerText: 'Created', allowFiltering: false, width: 75, autoFit: true},
            { field: 'DoesDocHeaderStillExist', headerText: '', width: 50, allowEditing: false, allowFiltering: false,
                template: '${getDoesDocHeaderForDataHubItemStillExist(data.DoesDocHeaderStillExist)}'
            },  
            { field: 'StatusText', headerText: 'Status',  width: 175, allowEditing: false, allowFiltering: false},
            { field: 'Department', headerText: 'Dept.', width: 175, allowEditing: false},
            { field: 'CustomerName', headerText: 'Customer',  width: 175, allowEditing: false},
            { field: 'VesselName', headerText: 'Vessel', width: 175, allowEditing: false},
            { field: 'CustomerReference', headerText: 'Cust. ref', width: 175, allowEditing: false},
            { field: 'OurReference', headerText: 'Our ref', width: 175, allowEditing: false},  
        ];

        if(sendToCloudErpEnabled) {
            gridColumns.push({ field: 'SendToCloudErpActions', headerText: '', allowFiltering: false, width: 75, autoFit: true, template: '${getDataHubIndexSendToCloudErpEnabledExtraActions(data.HasExportLogItems)}' });
        }

        self.dataHubItemsGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                columns: gridColumns,
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                allowResizing: false,
                enablePersistence: true,
                toolbarTemplate: '#toolbar-template',
                rowDataBound: (args) => {
                    let doesStillExist : boolean = args.data['DoesDocHeaderStillExist'];
                    if(doesStillExist == false) {
                        var row = ((args.row)as Element);
                        row.classList.add('no-hover');
                    }
                },
                dataBound: () => {
                    gridContentElement.find('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
                },
                actionBegin: (args) => {
                    if (!this.dataHubItemsGrid) {
                        return;
                    }

                    if (SyncfusionGridHelper.isFilterAction(args)) {
                        this.dataHubItemsGrid.pageSettings.currentPage = 1;
                    }
                },
                //actionComplete: actionComplete,
                pageSettings: { pageSize: 50 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
    
                    //loadingContainer.addClass('d-none');
                    //dataHubItemsTableContainer.removeClass('d-none');
                },
                recordClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        
                        if(parsedTarget.data('action') == 'view-export-log' || parsedTarget.parent().data('action') == 'view-export-log' ) {
                            var dataHubDocHeaderId = args.rowData["Id"];
                            self.sendToErpLogItemPopup.load(`?dataHubDocHeaderId=${dataHubDocHeaderId}&handler=SendToErpLog`, () => {
                                self.sendToErpLogItemPopup.getModalContainer()
                                    .find('pre')
                                    .each((index, element) => {
                                        var parsedElement = $(element);
                                        parsedElement.text(JSON.stringify(parsedElement.text(), undefined, 2));
                                    });    
                            }, undefined, undefined);
                        }
                        else {
                            var documentId = args.rowData["DocHeaderId"];
                            var exists = args.rowData["DoesDocHeaderStillExist"];
                            if(exists == 'True' || exists == 'true' || exists == true) {
                                var url = `/Company/DataWarehouse/${documentId}/Details`;
                                window.open(url, '_blank');
                            }
                        }


                    }
                }
            });
        self.dataHubItemsGrid.appendTo('#DataHubDocHeadersGrid');
        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.dataHubItemsGrid.pageSettings.currentPage = 1;
                self.dataHubItemsGrid.clearFiltering();
                self.dataHubItemsGrid.refreshHeader();
            })
        }
    }
}